import React, { useEffect, useState } from "react";
import Button from "../../component/Button";
import classes from "./style.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBox from "../../component/SearchBox";
import ReportList from "./components/ReportList";
import CreateReport from "../../modalComponents/CreateReport";
import GetUserPermission from "../../component/GetUserPermission";

const Report = () => {
  const [viewReport, setViewReport] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const addPermission = GetUserPermission({ key: 'add' });

  useEffect(() => {
    const pathName = location?.search?.split("?type=")?.at(1);
    if(pathName == 'add') {
      setShowPopUp(true)
    }
  }, [location])

  useEffect(() => {
    if (location?.pathname) {
      const pathName = location?.search?.split("?id=");
      const params = pathName[pathName?.length - 1];
      if (params) {
        setViewReport(true);
      } else {
        setViewReport(false);
      }
    }
  }, [location]);

  const redirectBack = () => {
    navigate(`/admin/report`);
  };

  const handleChange = (value) => {
    setSearchInput(value);
  };

  const handleClosePopUp = () => {
    setShowPopUp(false)
    redirectBack()
  }

  return (
    <>
      {viewReport ? (
        <ReportList />
      ) : (
        <div className={`${classes.manageUserWrapper}`}>
          <div className={`w-[100%] flex items-center justify-between`}>
            <div className={`layout-title`}>Reports</div>
            <div className="flex items-center">
              <SearchBox
                value={searchInput}
                onChange={handleChange}
                placeholder={"Find by customer name..."}
              />
              {addPermission &&
                <Button
                  text={"Create New Report"}
                  className={`ml-5`}
                  smallBtn
                  onClick={() => {navigate(`?type=add`);setShowPopUp(true)}}
                />
              }
            </div>
          </div>
          <div>
            <ReportList searchInput={searchInput} />
          </div>
        </div>
      )}
      {showPopUp ? (
        <CreateReport isOpen={showPopUp} closePopUp={handleClosePopUp} />
      ) : null}
    </>
  );
};

export default Report;
